module.exports = __webpack_public_path__ + "static/media/tiktok.a598ab1c.svg";